export default ({
  type: 'typeone',
  error: false,
  ghotel: {},
  ghotelstatus: {},
  ghotelModal: false,
} as unknown) as any
